import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  filterButtonWrapper: {
    display: 'flex',
    marginBottom: theme.app.spacing.sm,
    position: 'relative',
    flexDirection: 'column',

    '& .multi_select-input__label': {
      color: theme.app.colors.text.primary,
      fontSize: theme.app.typography.label.fontSize
    },
    '& .multi_select-input__input': {
      padding: theme.app.spacing.sm,
      height: 24,
      borderRadius: theme.app.borderRadius.sm,
      margin: `${theme.app.spacing.sm}px 0`,
      width: 'calc(100% - 16px)',
      fontFamily: theme.app.typography.fontFamily.main,
      fontSize: theme.app.typography.paragraph.fontSize,
      border: 'none',
      background: `${theme.app.colors.input.background} no-repeat calc(100% - 16px) center`,
      backgroundImage: `url(${require('../../assets/png/select.png')})`,

      '&:focus': {
        outline: 'none'
      },
      '&:disabled': {
        opacity: 0.5
      }
    },

    '& .multi_select-input__error': {
      top: 64,
      position: 'absolute',
      color: theme.app.indication.danger,
      fontSize: theme.app.typography.error.fontSize
    },

    '& .multi_select-input__dropper': {
      position: 'absolute',
      top: 65,
      left: 0,
      zIndex: 100,
      overflowY: 'auto',
      width: '100%',
      maxHeight: 168,
      borderRadius: theme.app.borderRadius.sm,
      color: theme.app.colors.text.primary,
      border: 'none',
      '& li': {
        height: 32,
        display: 'flex',
        padding: `0 ${theme.app.spacing.sm}px`,
        cursor: 'pointer',
        alignItems: 'center',
        backgroundColor: theme.app.colors.dropdown.background,
        zIndex: 1,
        fontSize: theme.app.typography.paragraph.fontSize,
        '&:hover': {
          color: theme.app.colors.text.primary,
          backgroundColor: theme.app.colors.dropdown.hover
        }
      },
      '& .multi_item-selected': {
        color: theme.palette.background.primary.contrastText,
        backgroundColor: theme.palette.background.primary.main
      },

      '& .multi_highlighted': {
        color: theme.app.colors.text.primary,
        backgroundColor: theme.app.colors.dropdown.hover
      }
    }
  },

  hoverSelect: {
    color: theme.palette.background.primary.contrastText,
    backgroundColor: theme.palette.background.primary.main
  },

  ulHidden: {
    display: 'none'
  },

  checkbox: {
    '&.Mui-checked': {
      color: theme.palette.background.primary.main,
      opacity: 1
    },
    '& .MuiSvgIcon-root': {
      color: theme.app.colors.border.dark
    }
  }
}))
